import { render, staticRenderFns } from "./ListDudi.vue?vue&type=template&id=a4e3d8bc&scoped=true&"
import script from "./ListDudi.vue?vue&type=script&lang=js&"
export * from "./ListDudi.vue?vue&type=script&lang=js&"
import style0 from "./ListDudi.vue?vue&type=style&index=0&id=a4e3d8bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e3d8bc",
  null
  
)

export default component.exports